import { getOnboardingVideo as getOnboardingVideoGenerat } from '../../../api/generated/sdk.gen';
import { handleResponse } from '../../../core/api/response-handler';
import type { OnboardingVideoDto } from '../../../api/generated/types.gen';

/**
 * Materialele video ale editiei curente, din configurarea backendului.
 *
 *     GET /api/editions/current/onboarding-video   →   OnboardingVideoDto
 *
 * 🔴 SDK-ul generat NU arunca la eroare, il INTOARCE (`ThrowOnError = false`):
 * un `await` fara `handleResponse(...)` merge mai departe ca si cum ar fi reusit,
 * chiar la 401 sau 500 — a produs deja un bug real in alta parte a produsului
 * (revocarea unui link raporta succes). De-aia apelul de aici trece prin
 * `handleResponse`, care arunca, deci `useQuery` chiar vede eroarea.
 *
 * ⚠️ `getOnboardingVideo` exista in `sdk.gen.ts` de la regenerarea din #129 si
 * pana acum **n-avea niciun apelant**. Asta e primul. Nu se regenereaza nimic in
 * PR-ul asta: regenerarea completa se face dupa PR-ul de spec al lui B2, si
 * oricum rescrie `baseURL` din `client.gen.ts` cu URL-ul DEV.
 *
 * ⚠️ Ambele campuri din DTO sunt OPTIONALE, deci un 200 poate sosi fara film.
 * Functia asta NU decide nimic despre asta — intoarce corpul asa cum a venit, iar
 * traducerea in stare de ecran e in `utils/video-sursa.ts`, care e pura si testata.
 */
export async function getOnboardingVideo(): Promise<OnboardingVideoDto> {
    const raspuns = await getOnboardingVideoGenerat();
    return handleResponse(raspuns) as OnboardingVideoDto;
}
